var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-body" },
      [
        _c("h5", { staticClass: "card-title" }, [
          _vm._v(_vm._s(_vm.$t("maintenance.activitySettings.modelName")))
        ]),
        _vm._v(" "),
        _c("ActivitySettingsEditor", { ref: "editor" }),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex justify-content-end mt-4" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary px-4",
              attrs: { type: "button" },
              on: { click: _vm.save }
            },
            [
              _c("i", { staticClass: "fa fa-check-circle me-2" }),
              _vm._v("\n        " + _vm._s(_vm.$t("btnSave")) + "\n      ")
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }